module.exports = __webpack_public_path__ + "img/wl_prod1_2.37f46b76.jpg";